import React, { useReducer, createContext, useEffect } from "react";
import {
  Routes,
  Route,
  HashRouter,
  useLocation,
  BrowserRouter as Router,
} from "react-router-dom";
import { NavLinkProvider } from "./context/NavLinkContext";
import ReactGA from "react-ga4";

// css
import "./App.css";
// import "~slick-carousel/slick/slick.css";
// import "~slick-carousel/slick/slick-theme.css";

// components
import NoticePage from "./components/noticePage/NoticePage";
import Navbar from "./components/navbar/Navbar";
import LoginPage from "./components/Login/LoginPage";
import PageOne from "./containers/PageOne";
import OfferingDetails from "./containers/OfferingDetails";
import DiWrapper from "./containers/DiWrapper";
import InvestmentsWrapper from "./containers/InvestmentsWrapper";
import PerformanceWrapper from "./containers/PerformanceWrapper";
import InvestorRelationsWrapper from "./containers/InvestorRelationsWrapper";
import TeamWrapper from "./containers/TeamWrapper";
import LiteratureWrapper from "./containers/LiteratureWrapper";
import ScrollToTop from "./containers/ScrollToTop";
import HelmetMeta from "./components/Helmet/HelmetMeta";

// Auth Context will pass the auth state from this component to any other component that needs it.
export const AuthContext = createContext();
const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
      };
    case "LOGOUT":
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    default:
      return state;
  }
};

// Track page views on route changes
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
};

function App() {
  const password = process.env.REACT_APP_PASS;
  const envType = process.env.REACT_APP_TYPE;
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const token = sessionStorage.getItem("userpass");
    const noticeAccepted = sessionStorage.getItem("accepted");

    if (noticeAccepted && noticeAccepted === "true") {
      dispatch({
        type: "LOGIN",
        payload: {
          token,
        },
      });
    }
    // eslint-disable-next-line
  }, []);

  const renderLogin = () => {
    if (envType === "test") {
      return (
        <HashRouter>
          <AuthContext.Provider value={{ state, dispatch }}>
            <NavLinkProvider>
              {!state.isAuthenticated ? null : <Navbar />}
              <ScrollToTop>
                <HelmetMeta />
                <PageTracker /> {/* <-- Moved tracking inside HashRouter */}
                <Routes>
                  <Route
                    exact
                    path="/"
                    element={
                      !state.isAuthenticated ? <NoticePage /> : <PageOne />
                    }
                  />
                  <Route
                    exact
                    path="/OfferingDetails"
                    element={
                      !state.isAuthenticated ? (
                        <NoticePage />
                      ) : (
                        <OfferingDetails />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/digitalinfrastructure"
                    element={
                      !state.isAuthenticated ? <NoticePage /> : <DiWrapper />
                    }
                  />
                  <Route
                    exact
                    path="/investments"
                    element={
                      !state.isAuthenticated ? (
                        <NoticePage />
                      ) : (
                        <InvestmentsWrapper />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/performance"
                    element={
                      !state.isAuthenticated ? (
                        <NoticePage />
                      ) : (
                        <PerformanceWrapper />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/investorrelations"
                    element={
                      !state.isAuthenticated ? (
                        <NoticePage />
                      ) : (
                        <InvestorRelationsWrapper />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/literature"
                    element={
                      !state.isAuthenticated ? (
                        <NoticePage />
                      ) : (
                        <LiteratureWrapper />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/team"
                    element={
                      !state.isAuthenticated ? <NoticePage /> : <TeamWrapper />
                    }
                  />
                </Routes>
              </ScrollToTop>
            </NavLinkProvider>
          </AuthContext.Provider>
        </HashRouter>
      );
    } else {
      return (
        <HashRouter>
          <AuthContext.Provider value={{ state, dispatch }}>
            <NavLinkProvider>
              {!state.isAuthenticated ? null : <Navbar />}
              <ScrollToTop>
                <Routes>
                  <Route
                    exact
                    path="/"
                    element={
                      !state.isAuthenticated ? <NoticePage /> : <PageOne />
                    }
                  />
                  <Route
                    exact
                    path="/OfferingDetails"
                    element={
                      !state.isAuthenticated ? (
                        <NoticePage />
                      ) : (
                        <OfferingDetails />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/digitalinfrastructure"
                    element={
                      !state.isAuthenticated ? <NoticePage /> : <DiWrapper />
                    }
                  />
                  <Route
                    exact
                    path="/investments"
                    element={
                      !state.isAuthenticated ? (
                        <NoticePage />
                      ) : (
                        <InvestmentsWrapper />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/performance"
                    element={
                      !state.isAuthenticated ? (
                        <NoticePage />
                      ) : (
                        <PerformanceWrapper />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/investorrelations"
                    element={
                      !state.isAuthenticated ? (
                        <NoticePage />
                      ) : (
                        <InvestorRelationsWrapper />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/literature"
                    element={
                      !state.isAuthenticated ? (
                        <NoticePage />
                      ) : (
                        <LiteratureWrapper />
                      )
                    }
                  />
                  <Route
                    exact
                    path="/team"
                    element={
                      !state.isAuthenticated ? <NoticePage /> : <TeamWrapper />
                    }
                  />
                </Routes>
              </ScrollToTop>
            </NavLinkProvider>
          </AuthContext.Provider>
        </HashRouter>
      );
    }
  };

  return <div className="App">{renderLogin()}</div>;
}

// Separate component to track page views
const PageTracker = () => {
  usePageTracking();
  return null;
};

export default App;
